// extracted by mini-css-extract-plugin
export var socket = "styles-module--socket--d8635";
export var socketWrapper = "styles-module--socketWrapper--c0ad7";